export default function Certificates({selectedYear}) {
  return (
    <>
      <div className="row">
        <h3 className="m-3"></h3>
      </div>
      <div className="m-3 p-4 lk-start-page">
        <p className="mb-0">
          Здесь будут отображаться свидетельства лаборатории, полученные в ходе исполнения договора
          за {selectedYear} год. 
        </p>
      </div>
    </>
  );
}
